import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { DefaultRequestBodyType } from "../../../constant/document";
import { del, patch, post } from "../../../services/API/ApiClient";
import { openErrorNotification, openNotification } from "../../../components/Template/NotificationComponent";
import { autoRefreshFrequency } from "../../../constant/constant";

export const fetchUsers = createAsyncThunk<any, any, { state: RootState }>("transcribe/fetchUsers", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const reqBody = {
      ...getState().UsersPageState.currentRequestBody,
    };
    dispatch(updateUsersRequestBody(reqBody));
    //response return
    const response = await post("/users/search", "Transcribe", reqBody);
    return response.data.results;
  } catch (e) {
    return rejectWithValue(e);
  }
});

//Infinite Scrolling
export const fetchPaginateUsers = createAsyncThunk<any, any, { state: RootState }>("transcribe/fetchPaginateUsers", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const reqBody = {
      ...getState().UsersPageState.currentRequestBody,
      PageNum: getState().UsersPageState.pagination.page,
    };
    //response return
    const response = await post("/users/search", "Transcribe", reqBody);
    return response.data.results;
  } catch (e) {
    return rejectWithValue(e);
  }
});

//Search Users
export const searchUsers = createAsyncThunk<any, { searchKeyword: string }, { state: RootState }>("transcribe/searchUsers", async (args, { getState, dispatch }) => {
  dispatch(resetUsersTable());
  dispatch(
    updateUsersRequestBody({
      ...getState().UsersPageState.currentRequestBody,
      Keyword: args.searchKeyword,
    })
  );
  dispatch(fetchUsers({}));
});

//Fetching the RefreshUsers
export const fetchRefreshUsers = createAsyncThunk<any, any, { state: RootState }>("transcribe/fetchRefreshUsers", async (args, { getState, dispatch, rejectWithValue }) => {
  const currentDataLength = getState().UsersPageState.data.length === 0 ? 30 : getState().UsersPageState.data.length;
  try {
    const reqBody = {
      ...getState().UsersPageState.currentRequestBody,
      pageSize: Math.ceil(currentDataLength / 30) * 30,
    };
    //response return
  } catch (e) {
    return rejectWithValue(e);
  }
});

//Auto Refreshing the Users
export const autoRefreshUsers = createAsyncThunk<any, any, { state: RootState }>("transcribe/autoRefreshUsers", async (args, { getState, dispatch, rejectWithValue }) => {
  if (getState().UsersPageState.autoRefreshUsersState.currentIntervalId) {
    clearInterval(getState().UsersPageState.autoRefreshUsersState.currentIntervalId);
  }
  if (getState().UsersPageState.autoRefreshUsersState.autoRefresh) {
    const intervalId = setInterval(() => {
      dispatch(fetchRefreshUsers({}));
    }, autoRefreshFrequency);
    dispatch(setUsersAutoRefresh({ intervalId }));
  }
});

export const deleteUsers = createAsyncThunk<any, any, { state: RootState }>("transcribe/deleteUsers", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await del(`/users/${args}`, "Transcribe");
    await dispatch(fetchUsers({}));

    //response return
  } catch (e) {
    return rejectWithValue(e);
  }
});
export const createUsers = createAsyncThunk<any, any, { state: RootState }>("transcribe/createUsers", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await post("/users", "Transcribe", args);
    openNotification("Create User", "User created successfully ", "top");
    await dispatch(fetchUsers({}));

    //response return
  } catch (e) {
    openErrorNotification("Create User", "Error creating user, please try again.", "top");
    return rejectWithValue(e);
  }
});

export const switchOnUser = createAsyncThunk<any, any, { state: RootState }>("transcribe/switchOnUser", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await patch(`/users/${args.id}/enable-user`, "Transcribe", {});
    openNotification("Enable User", "User enabled successfully", "top");
    //response return
  } catch (e) {
    openErrorNotification("Enable User", "Error enabling user, please try again.", "top");
    return rejectWithValue(e);
  }
});
export const switchOffUser = createAsyncThunk<any, any, { state: RootState }>("transcribe/switchOffUser", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await patch(`/users/${args.id}/disable-user`, "Transcribe", {});
    openNotification("Disable User", "User disabled successfully", "top");
    //response return
  } catch (e) {
    openErrorNotification("Disable User", "Error disabling user, please try again.", "top");
    return rejectWithValue(e);
  }
});

// Start the generic actions for Users
export const updateUsersRequestBody = createAction<DefaultRequestBodyType>("transcribe/updateUsersRequestBody");
export const resetUsersTable = createAction("transcribe/resetUsersTable");
export const setUsersAutoRefresh = createAction<{ intervalId: NodeJS.Timer }>("transcribe/setUsersAutoRefresh");
export const switchUsersAutoFresh = createAction<{ autoRefresh: boolean }>("transcribe/switchUsersAutoFresh");
export const stopUsersAutoRefresh = createAction("transcribe/stopUsersAutoRefresh");
// End the generic actions for Users
export const setCurrentRecord = createAction<any>("transcribe/setCurrentRecord");

//Modal
export const openCreateUsersModal = createAction("transcribe/openCreateUsersModal");
export const closeCreateUsersModal = createAction("transcribe/closeCreateUsersModal");
export const openDeleteUsersModal = createAction("transcribe/openDeleteUsersModal");
export const closeDeleteUsersModal = createAction("transcribe/closeDeleteUsersModal");
export const openOrganizationModal = createAction("transcribe/openOrganizationModal");
export const closeOrganizationModal = createAction("transcribe/closeOrganizationModal");
